<template>
  <img
    class="image-empty"
    :alt="imageTitle"
    src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
  >
</template>

<script>
export default {
  name: 'ImageEmpty',
  props: {
    imageTitle: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style lang="scss">
.image-empty {
  width: 0;
  height: 0;
  display: none;
}
</style>
